import styled from 'vue3-styled-components';

export const AccountPageContainer = styled.div`
    padding: 20px;
    margin-bottom: 20px;
`;

export const SubTitle = styled.h1`
    font-size: 20px;
    font-weight: bold;

    span {
        color: #666;
        font-size: 14px;
    }
`;

export const AccountButton = styled.button`
    background: #0f4c5c;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    margin-left: 50px;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const Select = styled.select`
  flex: 1;
  padding: 7px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  max-width: 400px;
  margin-left: 10px;
  margin-right: 5px;

  &:focus {
    outline: none;
    border-color: #4dabf7;
  }
`;

export const TableContainer = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
    overflow: auto;
    border: 1px solid #e2e8f0;
    padding: 15px;
    min-height: 650px;
    
    table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        font-size: 14px;
        
        /* 테이블 크기 조정 가능하게 설정 */
        table-layout: auto;
        
        th, td {
            padding: 8px 8px;
            text-align: center;
            border: 1px solid #ddd;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            
            /* 각 셀의 최소/최대 너비 설정 */
            min-width: 80px;  /* 최소 너비 */
            max-width: 300px; /* 최대 너비 */
        }
        
        /* 각 열의 기본 너비 설정 */
        th:nth-child(1), td:nth-child(1) { width: 1%; }  /* 순번 */
        th:nth-child(2), td:nth-child(2) { width: 5%; }  /* 등록일 */
        th:nth-child(3), td:nth-child(3) { width: 10%; } /* 고객명 */
        th:nth-child(4), td:nth-child(4) { width: 8%; }  /* 인정번호 */
        th:nth-child(5), td:nth-child(5) { width: 8%; } /* 연락처 */
        th:nth-child(6), td:nth-child(6) { width: 4%; }  /* 가상계좌 은행 */
        th:nth-child(7), td:nth-child(7) { width: 8%; } /* 가상계좌번호 */
        th:nth-child(8), td:nth-child(8) { width: 12%; } /* 입금가능기간 */
        th:nth-child(9), td:nth-child(9) { width: 5%; }  /* 항목명 */
        th:nth-child(10), td:nth-child(10) { width: 8%; } /* 입금금액 */
        th:nth-child(11), td:nth-child(11) { width: 12%; } /* 입금여부 */
        th:nth-child(12), td:nth-child(12) { width: 10%; } /* 비고 */
        th:nth-child(13), td:nth-child(13) { width: 3%; } /* 복사 */
        
        th {
            background: #fb8b24;
            font-weight: bold;
            position: relative;
            
            &:hover::after {
                background-color: rgba(0, 0, 0, 0.2);
            }
        }

        tr:hover {
            background-color: #ffeccc;
            cursor: pointer;
        }
    }
`;

export const AccountCopyBtn = styled.button`
  cursor: pointer;
  color: #0f4c5c;
  background: none;
  border: none;
  padding: 5px 10px;
  font-size: 16px;
  transition: color 0.3s;
  font-weight: bold;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const AccountDateButton = styled.button`
    padding: 8px 10px;
    background: #0f4c5c;
    color: white;
    border: 1px solid #0f4c5c;
    border-radius: 3px;
    cursor: pointer;
    font-size: 13px;
    margin: 0 2px;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

// 버튼 그룹 컨테이너 추가
export const ButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: auto;
`;

// 가상계좌 버튼 스타일 수정
export const VirtualAccountButton = styled.button`
    padding: 6px 10px;
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 14px;
    display: flex;         
    align-items: center;     
    justify-content: center;
    white-space: nowrap;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    &:hover {
        background: #0a3b47;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    &:active {
        transform: translateY(1px);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }
`;

export const SearchSection = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background: white;
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
`;

// 필터 컨테이너 추가
export const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 15px;
`;

// 상태 필터 컨테이너 스타일 업데이트
export const StatusFilterContainer = styled.div`
    display: flex;
    align-items: center;
    background: white;
    padding: 10px 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    gap: 12px;
    margin-left: auto;
    transition: all 0.3s ease;
`;

// 상태 필터 레이블 스타일 업데이트
export const FilterLabel = styled.span`
    font-weight: 600;
    color: #444;
    font-size: 14px;
    position: relative;
    padding-right: 12px;
    
    &:after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 16px;
        width: 1px;
        background-color: #e0e0e0;
    }
`;

// 필터 뱃지 스타일 추가
export const FilterBadge = styled.div`
    display: inline-flex;
    align-items: center;
    background: ${props => props.active ? '#0f4c5c' : '#f0f0f0'};
    color: ${props => props.active ? 'white' : '#555'};
    border-radius: 20px;
    padding: 5px 12px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-right: 3px;
    
    &:hover {
        background: ${props => props.active ? '#0a3b47' : '#e0e0e0'};
    }
`;

// 필터 그룹 컨테이너 추가
export const FilterGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SearchInput = styled.input`
    width: 200px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;

    &:focus {
        outline: none;
        border-color: #0066cc;
        box-shadow: 0 0 5px rgba(0, 102, 204, 0.5);
    }
`;

export const SearchButton = styled.button`
    box-shadow: 0 5px 9px -1px rgba(0,0,0,0.3), 0 4px 18px 0 rgba(0,0,0,0.2);
    border-radius: 5px;
    border: none;
    background: #fff;
    color: #000;
    width: 45px;
    margin-left: 5px;
    margin-right: 50px;
    height: 33px;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
      }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const SearchRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    gap: 15px;

    label {
        min-width: 80px;
        font-weight: 500;
    }

    input[type="radio"] {
        margin-right: 1px;
    }
`;

export const SearchField = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    select {
        padding: 5px;
        border: 1px solid #ddd;
        border-radius: 3px;
        min-width: 100px;
    }

    input[type="date"] {
        padding: 4px 8px;
        border: 1px solid #ddd;
        border-radius: 3px;
    }

    input[type="radio"] {
        margin-right: 5px;
    }
`;

export const ResultCount = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 30px;
    margin-bottom: 20px;
    color: #333;
    font-size: 15px;
    font-weight: 500;

    .stat-item {
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 8px 8px;
        background: white;
        border-radius: 6px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        border: 1px solid #e0e0e0;
        cursor: pointer;
    }

    .value {
        font-size: 16px;
        font-weight: 700;
        color: #1565C0;
        background: rgba(21, 101, 192, 0.15);
        padding: 4px 12px;
        border-radius: 4px;
    }

    .warning {
        color: #D32F2F;
        background: rgba(211, 47, 47, 0.15);
    }

    .success {
        color: #2E7D32;
        background: rgba(46, 125, 50, 0.15);
    }
`;

// * 페이지네이션
export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 10px;
`;

export const PaginationButton = styled.button`
    padding: 6px 12px;
    border: 1px solid #ddd;
    background-color: white;
    cursor: pointer;
    border-radius: 4px;

    .material-design-icon {
        transform: scale(2.0);  // 아이콘 크기만 1.5배로 키움
    }

    &:disabled {
        background-color: #ffeccc;
        cursor: not-allowed;
    }
    
    &:hover:not(:disabled) {
        background-color: #ffeccc;
    }
`;

export const PaginationNumbers = styled.div`
    display: flex;
    gap: 5px;
`;

export const PaginationNumber = styled.button`
    padding: 8px 12px;
    border: 1px solid #ddd;
    background-color: white;
    cursor: pointer;
    border-radius: 4px;
    
    &.active {
        background-color: #fb8b24;
        color: white;
        border-color: #fb8b24;
    }
    
    &:hover:not(.active) {
        background-color: #ffeccc;
    }
`;

export const OrderViewButton = styled.button`
    box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 1px 6px 0 rgba(0,0,0,0.15);
    border-radius: 5px;
    border: 1px solid #fb8b24;
    background: #fff;
    color: #000;
    margin-top: 2px;
    height: 25px;
    padding: 0 8px;
    font-size: 12px;

    &:hover {
        cursor: pointer;
        background-color: #0f4c5c;
        color: #fff;
        border-color: #0f4c5c;
        box-shadow: 0 4px 6px -2px rgba(0,0,0,0.25), 0 2px 8px 0 rgba(0,0,0,0.18);
    }

    &:active {
        background-color: #0f4c5c;
        box-shadow: 0 2px 4px -2px rgba(0,0,0,0.2), 0 1px 4px 0 rgba(0,0,0,0.15);
        transform: translateY(1px);
    }
`;